/**
 * Generic REST Endpoint for: list, add, edit & delete
 *
 * let endpoint = new CrudEndpoint('http://server/api')
 * let url = endpoint.list({from:0, size:25})
 * // url = "http://server/api/list?from=0&size=25"
 */

import { isEmpty, has, isString } from "lodash"

const defaultUri = {
  list: "{base}",
  create: "{base}",
  id: "{base}/id",
  edit: "{base}/id",
  delete: "{base}/id"
}

export default class CrudEndpoint {

  constructor(base, config = defaultUri){
    this._base = base;
    this.config = config;
  }

  url(key){
    if(!isEmpty(key) && has(this.config, key)){
      let url = "" || this.config[key];
      if(url.length){
        return url.replace("{base}", this._base);
      }
    }
    return this._base;
  }

  queryString(params = {}){
    if(isString(params)){
      return params.length? '?' + params : params;
    }
    let queryString = "", arr = [], key, value;
    for(key in params){
      value = params[key];
      if(value !== null && value!==undefined){
        arr.push(key.toString() + '=' + value.toString())
      }
    }
    if(arr.length){
      queryString = '?' + arr.join('&')
    }
    return queryString;
  }

  /*
   * Endpoints (urls)
   */

  base(args){
   return this.url() + this.queryString(args);
  }

  list(args){
    return this.url("list") + this.queryString(args);
  }

  id(id, args) {
    id = id.toString();
		return this.url("id") + '/' + id + this.queryString(args);
	}

	create(args) {
		return this.url("create") + this.queryString(args);
	}

	update(id, args) {
    id = id.toString();
		return this.url("update") + '/' + id + this.queryString(args);
	}

  delete(id, args) {
    id = id.toString();
		return this.url("delete") + '/' + id + this.queryString(args);
	}

}



// WEBPACK FOOTER //
// ./src/provider/lib/CrudEndpoint.js